import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@app/api/auth/useAuth';
import { withAuthLang } from '@app/i18n';
import AuthLayout from '@shared/ui/auth/AuthLayout';
import LoginHeader from '@shared/ui/auth/LoginHeader';
import { PasswordInput, EmailInput } from '@shared/ui/forms/inputs';
import { ThemeButton } from '@shared/ui/buttons';
import { isEmptyObject } from '@utils/helpers';
import { validateServerErrors } from '@utils/validation';

export default function LoginPage() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      email: '',
      password: '',
    },
  });

  async function onSubmit(data) {
    try {
      await login(data);
    } catch (error) {
      validateServerErrors(setError, error);
    }
  }

  return (
    <AuthLayout>
      <form className="auth__block" onSubmit={handleSubmit(onSubmit)}>
        <div className="block-pd-x block-pd-y">
          <LoginHeader />
          <div className="form">
            <EmailInput errors={errors} control={control} />
            <PasswordInput
              error={errors.password}
              control={control}
              name="password"
              label={t('password')}
              placeholder={t('enter_password')}
              noValidation
            />
            <Link
              className="dashed-btn m-l-auto"
              to={withAuthLang('/forgot-password')}
            >
              {t('forgot_password')}
            </Link>
          </div>
        </div>
        <div className="dialog-actions">
          <ThemeButton
            type="submit"
            endIcon="chevron-right"
            disabled={!isEmptyObject(errors)}
            loading={isSubmitting}
          >
            {t('sign_in_btn')}
          </ThemeButton>
        </div>
      </form>
    </AuthLayout>
  );
}
